import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as dashboardActions from "src/redux/slices/dashboardSlice";
import BarChart from "src/components/ui/chart/BarChart";
import { currencyFormatter } from "src/utils/common";

interface SalesOverviewCardProps {
  days: number;
  enabled?: boolean;
}

const SalesOverviewCard: React.FC<SalesOverviewCardProps> = ({
  days,
  enabled = true,
}) => {
  const dispatch = useAppDispatch();
  const { tenantSalesOverview } = useAppSelector((state) => state.dashboard);

  useEffect(() => {
    if (!enabled) return;
    dispatch(dashboardActions.getTenantSalesOverviewRequest({ days }));
  }, [dispatch, days, enabled]);

  if (!enabled) return null;

  const data = tenantSalesOverview.data?.data || [];

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-gray-700">Sales Overview</h2>
        <span className="text-xs text-gray-400">This week</span>
      </div>
      <BarChart
        data={data}
        dataKey="totalSales"
        xKey="date"
        hideXAxis
        hideYAxis
        barColor="#A5B4FC"
        barRadius={[8, 8, 8, 8]}
        tooltipFormatter={(value?: number) =>
          currencyFormatter(value || 0, "IN", 2)
        }
      />
    </div>
  );
};

export default SalesOverviewCard;
